export interface NotificacaoBackoffice {
  id: string;
  titulo: string;
  descricao: string;
  tipo: 'critico' | 'alerta' | 'info' | 'sucesso';
  modulo: 'financeiro' | 'atendimento' | 'empresas' | 'comunicados' | 'configuracoes' | 'auditoria';
  link: string;
  data: string;
  lida: boolean;
  badge?: string;
}

export const notificacoesBackoffice: NotificacaoBackoffice[] = [
  {
    id: 'NOTIF-001',
    titulo: 'Operação rejeitada',
    descricao: 'Crédito #OP-007 de R$ 2.450,00 foi rejeitado por dados bancários incompletos',
    tipo: 'critico',
    modulo: 'financeiro',
    link: '/backoffice/financeiro',
    data: '2026-05-08T14:30:00Z',
    lida: false,
    badge: 'financeiro',
  },
  {
    id: 'NOTIF-002',
    titulo: 'Empresa suspensa',
    descricao: 'Saúde Total (EMP-006) foi suspensa por inadimplência no plano Básico',
    tipo: 'critico',
    modulo: 'empresas',
    link: '/backoffice/empresas/EMP-006',
    data: '2026-05-06T11:30:00Z',
    lida: false,
    badge: 'empresas',
  },
  {
    id: 'NOTIF-003',
    titulo: '3 chamados urgentes pendentes',
    descricao: 'SUP-001, SUP-003 e SUP-008 aguardam atendimento prioritário',
    tipo: 'critico',
    modulo: 'atendimento',
    link: '/backoffice/atendimento',
    data: '2026-05-08T09:00:00Z',
    lida: false,
    badge: 'atendimento',
  },
  {
    id: 'NOTIF-004',
    titulo: 'Comunicado enviado',
    descricao: '"Atualização de Taxas de Resgate" entregue para 1.884 destinatários',
    tipo: 'sucesso',
    modulo: 'comunicados',
    link: '/backoffice/comunicados',
    data: '2026-05-08T10:00:00Z',
    lida: false,
    badge: 'comunicados',
  },
  {
    id: 'NOTIF-005',
    titulo: 'Configuração alterada',
    descricao: 'André Costa modificou a taxa de processamento PIX de 2.5% para 2.0%',
    tipo: 'info',
    modulo: 'configuracoes',
    link: '/backoffice/configuracoes',
    data: '2026-05-07T16:20:00Z',
    lida: false,
    badge: 'config',
  },
  {
    id: 'NOTIF-006',
    titulo: 'Empresa ativada',
    descricao: 'Expresso Distribuidora (EMP-005) teve cadastro aprovado e foi ativada',
    tipo: 'sucesso',
    modulo: 'empresas',
    link: '/backoffice/empresas/EMP-005',
    data: '2026-05-07T14:10:00Z',
    lida: false,
    badge: 'empresas',
  },
  {
    id: 'NOTIF-007',
    titulo: 'Saque aprovado',
    descricao: 'Operação #OP-005 de R$ 850,00 aprovada para João Silva',
    tipo: 'sucesso',
    modulo: 'financeiro',
    link: '/backoffice/financeiro',
    data: '2026-05-08T14:32:00Z',
    lida: false,
    badge: 'financeiro',
  },
  {
    id: 'NOTIF-008',
    titulo: 'Manutenção agendada',
    descricao: 'Janela de manutenção programada para 07/05 às 02:00 — sistema ficará indisponível',
    tipo: 'alerta',
    modulo: 'comunicados',
    link: '/backoffice/comunicados',
    data: '2026-05-05T14:00:00Z',
    lida: false,
    badge: 'comunicados',
  },
  {
    id: 'NOTIF-009',
    titulo: 'Empresa editada',
    descricao: 'TechBrasil (EMP-003) teve email e telefone atualizados no cadastro',
    tipo: 'info',
    modulo: 'empresas',
    link: '/backoffice/empresas/EMP-003',
    data: '2026-05-06T10:15:00Z',
    lida: false,
    badge: 'empresas',
  },
  {
    id: 'NOTIF-010',
    titulo: 'Tentativa de acesso suspeita',
    descricao: 'Login falhou de IP 203.45.67.89 com email hacker@email.com',
    tipo: 'critico',
    modulo: 'auditoria',
    link: '/backoffice/auditoria',
    data: '2026-05-05T22:45:00Z',
    lida: false,
    badge: 'auditoria',
  },
];

export function getTipoConfig(tipo: string) {
  switch (tipo) {
    case 'critico':
      return {
        icon: 'ri-error-warning-line',
        color: 'text-red-600',
        bg: 'bg-red-50',
        border: 'border-red-200',
        dot: 'bg-red-500',
      };
    case 'alerta':
      return {
        icon: 'ri-alert-line',
        color: 'text-amber-600',
        bg: 'bg-amber-50',
        border: 'border-amber-200',
        dot: 'bg-amber-500',
      };
    case 'sucesso':
      return {
        icon: 'ri-check-line',
        color: 'text-emerald-600',
        bg: 'bg-emerald-50',
        border: 'border-emerald-200',
        dot: 'bg-emerald-500',
      };
    default:
      return {
        icon: 'ri-information-line',
        color: 'text-blue-600',
        bg: 'bg-blue-50',
        border: 'border-blue-200',
        dot: 'bg-blue-500',
      };
  }
}

export function getModuloBadgeColor(modulo: string) {
  switch (modulo) {
    case 'financeiro': return 'bg-emerald-100 text-emerald-700';
    case 'atendimento': return 'bg-blue-100 text-blue-700';
    case 'empresas': return 'bg-purple-100 text-purple-700';
    case 'comunicados': return 'bg-indigo-100 text-indigo-700';
    case 'configuracoes': return 'bg-gray-100 text-gray-700';
    case 'auditoria': return 'bg-amber-100 text-amber-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}